/**
 * RequestorDetail — one person, and everywhere they are assigned (OPEN-053).
 *
 * The reverse view. Until this existed you could ask "who is on this site" but not "which sites
 * is Jane on", which is exactly the question you need answered before deactivating someone or
 * handing their locations to a colleague.
 *
 * Follows the `TankBatteryDetail` / `WellDetail` pattern — the tab swaps to this pane rather
 * than opening a modal, because a person on a few hundred locations needs the room.
 *
 * The body is `RequestorSummary`, shared with the Job Board's popup (86bazkeyn) so the two
 * cannot drift; this file adds only the pane framing.
 */
import * as React from 'react';
import { ArrowLeft } from 'lucide-react';
import { type Requestor } from './hooks';
import { RequestorSummary } from './RequestorSummary';

export interface RequestorDetailProps {
  readonly requestor: Requestor;
  readonly canManage: boolean;
  readonly onEdit: () => void;
  readonly onClose: () => void;
}

export function RequestorDetail({
  requestor,
  canManage,
  onEdit,
  onClose,
}: RequestorDetailProps): React.JSX.Element {
  return (
    <div>
      <button
        type="button"
        onClick={onClose}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '13px',
          color: 'var(--color-text-secondary)',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          marginBottom: '12px',
          padding: 0,
        }}
      >
        <ArrowLeft size={14} aria-hidden="true" /> Back to requestors
      </button>

      <RequestorSummary requestor={requestor} onEdit={canManage ? onEdit : undefined} />
    </div>
  );
}
